<template>
    <svg class="plus-icon" focusable="false" width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <desc>Created with Sketch.</desc>
        <g class="UI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="cmhr-edu-resource-toolkit-02B-filtered-collection" transform="translate(-495.000000, -742.000000)" fill="#232323">
                <g class="filter-sidebar" transform="translate(220.000000, 712.000000)">
                    <g class="filter-grade-level">
                        <g class="+" transform="translate(275.000000, 30.000000)">
                            <g>
                                <rect x="5" y="0" width="2" height="12"></rect>
                                <rect transform="translate(6.000000, 6.000000) rotate(90.000000) translate(-6.000000, -6.000000) " x="5" y="0" width="2" height="12"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style scoped lang="scss">
</style>

<script>
    export default {
        name: "PlusIcon"
    }
</script>
